<template>
  <div class="advanced-search">
    <h3>筛选条件</h3>
    <div class="search-bar" v-for="(item, index) in count" :key="index">
      <van-dropdown-menu>
        <van-dropdown-item v-model="item.field" :options="conditions" />
      </van-dropdown-menu>
      <input type="text" v-model="item.value">
      <div class="btn">
	      <van-icon name="plus" v-if="index === 0" @click="addItem"/>
	      <van-icon name="minus" v-else @click="delItem(index)"/>
      </div>
    </div>
    <div class="btn-group">
      <div class="btn clear" @click="onEmpted">清空条件</div>
      <div class="btn search" @click="onAdvancedSearch">搜索</div>
    </div>
  </div>
</template>

<script>
import {
  defineComponent,
  ref
} from "vue";
import {isNotEmpty} from '../utils/util';
import { Toast } from 'vant';
import store from '@/store';
import router from '../router';
import {SEARCH_ADVANCED} from '../utils/consts';

export default defineComponent({
  name: 'AdvancedSearch',
  setup() {
    const count = ref([{field: 'title', value: ''}]);
    const conditions = ref([
        {
            text:'题名',
            value:'title'
        },{
            text:'责任者',
            value:'author'
        },{
            text:'出版社',
            value:'publisher'
        },{
            text:'ISBN',
            value:'isbn'
        }
      ]);
    const addItem = () => {
        count.value.push({field: 'title', value: ''});
		};
    const delItem = (index) => {
        count.value.splice(index, 1);
    };
    // 高级搜索
    const onAdvancedSearch = () => {
        const validFields = count.value.filter(field => isNotEmpty(field.value));
        if (validFields.length <= 0) {
            Toast('请输入搜索词');
            return;
        }
        const param = {
            'filterFieldList': [],
            'page': 1,
            'pageSize': 10,
            'sortField': 'relevance',
            'sortType': 'desc',
            'queryFieldList': []
        };
        param.queryFieldList = validFields;
        const params = {
            type: SEARCH_ADVANCED,
            param: param
        };
        store.commit('search', params);
        router.push({path:'/searchResults'});
    };
    const onEmpted = () => {
        count.value = [{field: 'title', value: ''}];
    };
    return {
        count,
		    conditions,
        addItem,
        delItem,
        onAdvancedSearch,
        onEmpted
    };
  },
});
</script>

<style scoped lang="less">
@import "../assets/css/advanced-search.less";
</style>
